import httpClient from "../axios/interceptors";
import { AxiosResponse } from "axios";
import { API } from "./endpoint";

// Backend response: MobileResponse.success({ data: MasterBangbow | null })
export const getBangbowSetting = async (): Promise<any> => {
  const res: AxiosResponse<any> = await httpClient.get(API.bangbowSetting);
  return res.data;
};


